import _get from "lodash/get";
// import moment from "moment";
const commonParsers = {};
// function dateFormat(inputDate, format) {
//   //parse the input date
//   const date = new Date(inputDate);

//   //extract the parts of the date
//   const day = date.getDate();
//   const month = date.getMonth() + 1;
//   const year = date.getFullYear();

//   //replace the month
//   format = format.replace("MM", month.toString().padStart(2, "0"));

//   //replace the year
//   if (format.indexOf("yyyy") > -1) {
//     format = format.replace("yyyy", year.toString());
//   } else if (format.indexOf("yy") > -1) {
//     format = format.replace("yy", year.toString().substr(2, 2));
//   }

//   //replace the day
//   format = format?.replace("dd", day.toString().padStart(2, "0"));

//   return format;
// }
commonParsers.vehiclesMasterData = (res) => {
  if (res) {
    res = res.result;
  }
  if (!res) {
    return [];
  }

  return res?.map((e) => ({
    id: _get(e, "id", null),
    name: _get(e, "name", null),
  }));
};

commonParsers.manufacturerData = (res) => {
  if (res) {
    res = res.result.manufacturers;
  }
  if (!res) {
    return [];
  }
  //return res;

  return res?.map((e) => ({
    id: _get(e, "id", null),
    name: _get(e, "name", null),
  }));
};

commonParsers.locationData = (res) => {
  if (res) {
    res = res.result?.data;
  }
  if (!res) {
    return [];
  }


  return res?.map((e) => ({
    id: _get(e, "id", null),
    name: _get(e, "name", null),
  }));
};

commonParsers.amenitiesData = (res) => {
 
  let data = [];

  if (res) {
    res = res.result;
  }
  if (!res) {
    return [];
  }

  data = res?.map((e) => ({
    id: _get(e, "id", null),
    name: _get(e, "name", null),
  }));

  return data;
};

commonParsers.networkData = (res) => {
  let data = [];

  if (res) {
    res = res.result;
  }
  if (!res) {
    return [];
  }

  data = res?.networks?.map((e) => ({
    id: _get(e, "id", null),
    name: _get(e, "name", null),
  }));

  return data;
};

commonParsers.chargerTypes = (res) => {
  let data = [];

  if (res) {
    res = res.result;
  }
  if (!res) {
    return [];
  }

  data = res?.map((e) => ({
    id: _get(e, "id", null),
    name: _get(e, "name", null),
    type:_get(e, 'type', null)
  }));

  return data;
};

commonParsers.VendorNameData = (res) => {

  if (res) {
    res = res?.result?.vendors;
  }
  if (!res) {
    return [];
  }

  return res?.map((e) => ({
    vendor_id: _get(e, "vendor_id", null),
    vendors_name: _get(e, "vendors_name", null),
  }));
};

commonParsers.OwnerDataParser = (res) => {
  if (res) {
   
    res = res.result;
  }
  if (!res) {
    return [];
  }
  // return res;

  // return res?.map((e) => ({
  //   id: _get(e, "id", null),
  //   name: _get(e, "name", null),
  //   mobile: _get(e, "mobile", null),
  //   email: _get(e, "email", null),
  //   pin: _get(e, "pin", null),
  //   query: _get(e, "query", null),
  // }));
  const parseTransactions = (t) =>
       
    t.map((e) => ({
        id:e.id ? e.id: "",
        name : e.name ? e.name : "",
        mobile : e.mobile ? e.mobile : "",
        email : e.email ? e.email : "",
        pin : e.pin ? e.pin : "",
        // date: e["date"] ? dateFormat("" + e["date"] + "", "dd/MM/yyyy") : "",
        // slot:
        // moment("2023-01-01 " + e["from_time"]).format("hh:mm A") +
        // " - " +
        // moment("2023-01-01 " + e["to_time"]).format("hh:mm A"),
        query : e.query ? e.query : "",
        created_at : e.created_at ? e.created_at : "",
       
 
    }));

const data = parseTransactions(res);



return data;
};


commonParsers.HostDataParser = (res) => {
  if (res) {
  
    res = res.result;
  }
  if (!res) {
    return [];
  }
  // return res;

  return res?.map((e) => ({
    id: _get(e, "id", null),
    name: _get(e, "name", null),
    mobile: _get(e, "mobile", null),
    email: _get(e, "email", null),
    pin: _get(e, "pin", null),
    created_at: _get(e, "created_at", null),
  }));
};



export { commonParsers };
